module.exports = __webpack_public_path__ + "assets/img/roles-wiki.d3943fdc.svg";